import { expertServices } from '../utils/constant'

export const facilityFormModels = (disabled, validateTime) => [
  {
    type: 'input',
    label: 'Facility name',
    dbField: 'name',
    colSpan: 24,
    rules: [{ required: true, message: 'This field is required' }]
  },
  {
    type: 'input',
    label: 'Address',
    dbField: 'address',
    colSpan: 24,
    rules: [{ required: true, message: 'This field is required' }]
  },
  {
    type: 'input',
    label: 'phone number',
    colSpan: 24,
    dbField: ['phone_number'],
    rules: [{ required: true, message: 'This field is required' }]
  },
  {
    type: 'multipleSelect',
    options: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ].map((day) => {
      return {
        value: day,
        label: day
      }
    }),
    dbField: ['open_days'],
    label: 'DAYS OPEN',
    colSpan: 24,
    rules: [{ required: true, message: 'This field is required' }]
  },
  {
    type: 'time',
    label: 'Open time',
    dbField: 'open_time',
    extraAttr: {
      format: 'h:mm A',
      disabledTime: (now) => ({
        disabledHours: () => disabled('hours', 'open'),
        disabledMinutes: (selectedHour) =>
          disabled('minutes', 'open', selectedHour)
      }),
      use12Hours: true,
      minuteStep: 1
    },

    colSpan: 24,
    rules: [
      { required: true, message: 'This field is required' },
      {
        validator: (rule, value) => validateTime('open', value)
      }
    ]
  },
  {
    type: 'time',
    label: 'Close time',
    dbField: 'close_time',
    extraAttr: {
      format: 'h:mm A',
      use12Hours: true,
      disabledTime: (now) => ({
        disabledHours: () => disabled('hours', 'close'),
        disabledMinutes: (selectedHour) =>
          disabled('minutes', 'close', selectedHour)
      }),

      minuteStep: 1
    },
    colSpan: 24,
    rules: [
      { required: true, message: 'This field is required' },
      {
        validator: (rule, value) => validateTime('close', value)
      }
    ]
  },
  {
    type: 'tagSelect',
    label: 'SERVICE',
    colSpan: 24,
    dbField: ['services'],
    options: expertServices,
    rules: [{ required: true, message: 'This field is required' }]
  }
]
